import { useNavigate } from "react-router"
import { useRef } from "react"
import { FormikProps } from "formik"
import { CreateRoomResourceForm } from "../../resourcesTypes"
import { useApiMutation } from "../../../../../../../core/api/useApiMutation"
import { SuccessDisplay } from "../../../../../../../core/api/errorTypes"
import { createResource, ServiceCenterResourcesQuery } from "../../resourcesApi"

import {
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_ROUTE,
    SERVICE_CENTER_ADMIN_ROUTE,
} from "../../../../../../../constants/routes"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../../shared/components/pageHeader/PageHeaderApi"
import { StandardButton } from "../../../../../../../shared/components/buttons/StandardButton"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../../shared/components/links/StandardBreadcrumbs"
import { CreateUpdateRoomForm } from "../../components/room/CreateUpdateRoomForm"
import { transformRoomFormToResource } from "./utils"
import { useDateTime } from "../../../../../../localization/useDateTime"

export function CreateRoom() {
    const navigate = useNavigate()
    const roomFormRef = useRef<FormikProps<CreateRoomResourceForm>>(null)
    const dateTimeFactory = useDateTime()

    const { mutate } = useApiMutation(createResource, {
        successDisplay: SuccessDisplay.SNACKBAR,
        async onSuccess(_, __, context) {
            await context.queryClient.invalidateQueries({
                queryKey: [ServiceCenterResourcesQuery.SERVICE_CENTER_RESOURCES],
            })
            navigate(SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE)
        },
    })

    const createRoom = (value: CreateRoomResourceForm) => {
        const updatedForm = transformRoomFormToResource(value, dateTimeFactory)
        mutate(updatedForm)
    }

    const handleSaveClick = () => {
        roomFormRef.current?.submitForm()
    }

    return (
        <>
            <LocalizedStrict id="service-center-admin-organization-resources-create-room-title" attrs={{ title: true }}>
                <PageHeader
                    page={Page.SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_ROOM_ROUTE}
                    title="Create room"
                    rightElement={
                        <LocalizedStrict id="support-create-company-create-button">
                            <StandardButton onClick={handleSaveClick}>
                                Create
                            </StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={SERVICE_CENTER_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="service-center-admin-nav-item-organization">
                            <BreadcrumbLink to={SERVICE_CENTER_ADMIN_ORGANIZATION_ROUTE}>Organization</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="service-center-admin-nav-item-organization-resources">
                            <BreadcrumbLink to={SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE}>
                                Resources
                            </BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="service-center-admin-nav-item-organization-resource-crate-room">
                            <Breadcrumb>Create room</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <CreateUpdateRoomForm ref={roomFormRef} onSubmit={createRoom} />
        </>
    )
}
